import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
    message = '404 Page Not Found';
    mounted() {
        setTimeout(() => { window.location.href = '/'; }, 3000);
    }
};
default_1 = __decorate([
    Component({
        name: 'Page404'
    })
], default_1);
export default default_1;
